module.exports = __webpack_public_path__ + "static/media/cash-vouchar.dfdc7aa0.png";